// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  eng: {},
  kor: {},
};

i18n.on("languageChanged", (lang) => {
  const storedLang = sessionStorage.getItem("lang");
  if (storedLang !== lang) {
    sessionStorage.setItem("lang", lang);
    window.location.reload();
  }
});

const initialLanguage = sessionStorage.getItem("lang") || "eng";

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: "eng",
  defaultNS: "DESC",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
